import { Component, OnInit, ViewChild, Input,ViewEncapsulation, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
import { Subscription } from 'rxjs';

import { formatDate } from '@angular/common';
import { DragulaService } from 'ng2-dragula';

//import constants
import { AppSettings } from '../../../../constants/app-settings';
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import services
import { DeadlineService } from '../../../../services/deadline.service';
import { ConfirmationDialogService } from '../../../general/modals/confirmation/confirmation.service';
import { GeneralService } from '../../../../services/general.service';


//import components
import { DeadlineCreateComponent } from '../deadline-create/deadline-create.component';

declare var $: any;


@Component({
  selector: 'app-deadline-list',
  templateUrl: './deadline-list.component.html',
  styleUrls: ['./deadline-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DeadlineListComponent implements OnDestroy, OnInit {
  getPhotoBase64; 

  @ViewChild('fileInput') fileInput;  
  message: string;
  
  today: number = Date.now();



  readonly AppSettings = AppSettings;
  readonly AppFrontRoutes = AppFrontRoutes;

  datatableOptions1: any;
  datatableTrigger1: Subject<any> = new Subject();
  datatableColsDefs1: any;
  datatableCols1: any;
  datatableAddCols1: any;

  @Input()  filter1: string;
  @Input()  filter2: string;
  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;

  addDeadlineModal: BsModalRef;
  deleteOption: any;
  selectedType: any;

  lang: any;
  records: any;
  // pageView: any;
  pageView: string = 'list';
  rolepermission: any;
  subs = new Subscription();
  tid: any;
  oid: any;

  constructor(
    private deadlineService: DeadlineService,
    private modalService: BsModalService,
    private generalService: GeneralService,
    private confirmationDialogService: ConfirmationDialogService,
    private route: ActivatedRoute,
    private router: Router,
    private ngxRolesService: NgxRolesService,
    private dragulaService: DragulaService,

  ) { }

  ngOnInit() {

    var role = this.ngxRolesService.getRole('timetable');
    
    this.rolepermission = '';
    if (role) {
      this.rolepermission = role.validationFunction[0];
    }

    this.filter1 = JSON.parse(localStorage.getItem('key'));
    this.getData();

    this.subs.add(this.dragulaService.dropModel("records")
    .subscribe(({ sourceModel, targetModel, item }) => {
      let arr = []; let table = [];
      // console.log(sourceModel);
      for (let employee of sourceModel) {
        arr.push(employee.timetabelId)
      }
      this.updsorting(arr, table);
    })
  );

    

  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();

    
  }

  datatableConfig(): void {

    this.datatableColumns();

    this.datatableOptions1 = {
      paging: false,
      bAutoWidth: false,
      bSortClasses: false,
      columnDefs: this.datatableColsDefs1,
      select: {
        style: 'multi',
        selector: 'td:first-child'
      },
      headerCallback: function (thead, data, start, end, display) {

        $('th:first-child input', thead).unbind('click');
        $('th:first-child input', thead).bind('click', () => {

          var table1 = new $.fn.dataTable.Api('#table1');

          var count = table1.rows({ selected: true }).count();
          let selected = true;

          if (count > 0) {
            table1.rows().deselect();
            selected = false;
          }
          else
            table1.rows().select();

          $('th:first-child input', thead).prop("checked", selected);

        });
      },
      initComplete: () => {

        var self = this;
        var table1 = new $.fn.dataTable.Api('#table1');
        
        table1
          .on('select deselect', function (e, dt, type, indexes) {

            var table1 = new $.fn.dataTable.Api('#table1');
            var selected = table1.rows({ selected: true }).indexes().toArray();

            if (selected.length === 0)
              self.deleteOption = false;
            else
              self.deleteOption = true;
          });

          var buttons1 = new $.fn.dataTable.Buttons(table1, {
            dom: {
              button: {
                className: ''
              }
            },
            buttons: [
              {
                extend: 'csv',
                text: this.lang.exportCsv,
                className: 'btn btn-info',
                exportOptions: {
                  columns: '.selected',
                  rows: function (idx, data, node) {
                    var dt = new $.fn.dataTable.Api('#table1');
                    var selected = dt.rows({ selected: true }).indexes().toArray();
                    if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                      return true;
      
                    return false;
                  }
                },
                title: "KaizenCluod DEMO Deadline "  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en') 
              },
              {
                extend: 'pdfHtml5',
                text: this.lang.exportPdf,
                className: 'btn btn-info',
                orientation: 'landscape',
                pageSize: 'A3',
                exportOptions: {
                  columns: '.selected',
                  rows: function (idx, data, node) {
                    var dt = new $.fn.dataTable.Api('#table1');
                    var selected = dt.rows({ selected: true }).indexes().toArray();
      
                    if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                      return true;
      
      
                    return false;
                  }
                },
                title: "KaizenCluod DEMO Deadline "  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en') 
              },
              {
                extend: 'excel',
                text: this.lang.exportExcel,
                className: 'btn btn-info',
                exportOptions: {
                  columns: '.selected',
                  rows: function (idx, data, node) {
                    var dt = new $.fn.dataTable.Api('#table1');
                    var selected = dt.rows({ selected: true }).indexes().toArray();
      
                    if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                      return true;
      
                    return false;
                  }
                },
                title: "KaizenCluod DEMO Deadline "  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en') 
              },
              {
                extend: 'print',
                text: this.lang.exportPrint,
                className: 'btn btn-info',
                exportOptions: {
                  columns: '.selected',
                  rows: function (idx, data, node) {
                    var dt = new $.fn.dataTable.Api('#table1');
                    var selected = dt.rows({ selected: true }).indexes().toArray();      
                    if (selected.length === 0 || $.inArray(idx, selected) !== -1)
                      return true;
      
                    return false;
                  }
                },
                title: "KaizenCluod DEMO Deadline "  + formatDate(new Date(), 'yyMMdd', 'en') + '_' + formatDate(new Date(), 'hhmmss', 'en') 
              },
            ], select: true
          }).container().appendTo($('#datatableExportBtn1'));
        
    
      }
    }

    this.filter1 = '';
    this.filter2 = '';

  }

  datatableColumns(): void{

    this.datatableColsDefs1 = [
      {
        targets: 0,
        visible: false,
        orderable: false,
      },
      {
        targets: 1,
        orderable: false,
        className: 'select-checkbox'
      },
    ];

    this.datatableCols1 = [
      { id: 2, value: this.lang.sno, isSelected: false },
      { id: 3, value: this.lang.type, isSelected: false },
      { id: 4, value: this.lang.description, isSelected: false },
      { id: 5, value: this.lang.renewalNote, isSelected: false },
      { id: 6, value: this.lang.created, isSelected: false },
      { id: 7, value: this.lang.lastAction, isSelected: false },
      { id: 8, value: this.lang.startingDate, isSelected: false },
      { id: 9, value: this.lang.repeatingPeriod, isSelected: false },
      { id: 10, value: this.lang.nextDeadline, isSelected: false },
      { id: 11, value: this.lang.daysleft, isSelected: false },
    ];

    this.datatableAddCols1 = [
      { id: 13, value: this.lang.attachments, isSelected: false },
    ];

  }

  // datatableFilter(): void{

  //   $.fn['dataTable'].ext.search.push((settings, data, dataIndex) => {
  //     const filt1 = data[3] || '';
  //     const filt2 = data[11] || '';
      
  //     // console.log(this.filter1);

  //     localStorage.setItem('key', JSON.stringify(this.filter1));

      
  //     var status = true;

           
  //     // if (this.filter2 && filt2 != this.filter2)
  //     //   status = false;

  //     if (this.filter1 && filt1 != this.filter1) {
  //       status = false;
  //     }

  //     if (this.filter2 != '') {
  //       if (this.filter2 == '' || this.filter2 == '1') {
  //         status = true;
  //       }
  //       else if (this.filter2 == '2' && filt2 < 0) {
  //         status = true;
  //       }
  //       else if (this.filter2 == '3' && filt2 >= 0) {
  //         status = true;
  //       }
  //       else {
  //         status = false;
  //       }
  //     }


      
  //     return status;
  //   });

  // }

  // datatableFilterAction(): void {
  //   console.log(this.filter1);
  //   this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //     dtInstance.draw();
  //   });
  // }

  datatableFilter(): void{

    let stored_filter = this.generalService.cookie('get', 'deadline_filter');

    if(stored_filter) {
      this.filter1 = stored_filter.filter1;
      this.filter2 = stored_filter.filter2;
    }

    $.fn['dataTable'].ext.search.push((settings, data, dataIndex) => {
      const filt1 = data[3] || '';
      const filt2 = data[11] || '';

      var status = true;

      if (this.filter1 && filt1 != this.filter1)
        status = false;
      if (this.filter2 && this.filter2 != '1') {
        if (this.filter2 == '2' && filt2 >= 0)
          status = false;
        if (this.filter2 == '3' && filt2 < 0)
          status = false;
        if(!Number(filt2))
          status = false;
      }

      return status;
    });

  }
  
  datatableFilterAction(): void {

    this.generalService.cookie('set', 'deadline_filter', {filter1: this.filter1, filter2 : this.filter2});

    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }




  getData() {
    // console.log('test'); return false;

    this.deadlineService.list()
      .subscribe(
        (res) => {

          // this.lang = res.data.language;
          this.lang = this.deadlineService.listLang(res);
          this.records = res.data.all_record;
          this.filter1 = this.filter1;

          // console.log(this.filter1);

          //load datatable
          this.datatableConfig();
          this.datatableFilter();

        }
      );

  }

  export1_select_deselect_all(event): void {

    let selected = false;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++)
      this.datatableCols1[i].isSelected = selected;
    
    for (var i = 0; i < this.datatableAddCols1.length; i++)
      this.datatableAddCols1[i].isSelected = selected;

    this.datatable_export1_choose_column();

  }

  export1_select_deselect(event): void {

    let selected = false;
    let id = event.target.value;

    if (event.target.checked)
      selected = true;

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].id == id)
        this.datatableCols1[i].isSelected = selected;
    }

    for (var i = 0; i < this.datatableAddCols1.length; i++) {
      if (this.datatableAddCols1[i].id == id)
        this.datatableAddCols1[i].isSelected = selected;
    }

    this.datatable_export1_choose_column();

  }

  datatable_export1_choose_column(): void {

    var table1_name = '#table1';
    var table1 = new $.fn.dataTable.Api(table1_name);

    for (var i = 0; i < this.datatableCols1.length; i++) {
      if (this.datatableCols1[i].isSelected)
        table1.column(parseInt(this.datatableCols1[i].id)).select();
      else
        table1.column(parseInt(this.datatableCols1[i].id)).deselect();
    }

    for (var i = 0; i < this.datatableAddCols1.length; i++) {
      if (this.datatableAddCols1[i].isSelected)
        table1.column(parseInt(this.datatableAddCols1[i].id)).select();
      else
        table1.column(parseInt(this.datatableAddCols1[i].id)).deselect();
    }

  }

  redirect() {
    this.router.navigateByUrl('/test', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([AppFrontRoutes.Deadline_List]);
    });
  }
  
  success(msg: any) {
    
    //show success message
    this.generalService.notify_msg('success', msg);

    //redirect the current page
    this.redirect();
  }

  error(msg: any) {
    this.generalService.notify_msg('error', msg);
  }
  
  add() {
    this.addDeadlineModal = this.modalService.show(DeadlineCreateComponent, { initialState: {'ID': '','langs': this.lang} });
  }

  edit(ID) {
    this.addDeadlineModal = this.modalService.show(DeadlineCreateComponent, { initialState: {'ID': ID, 'langs': this.lang, 'redirect' : ''} });
  }

  delete(ID) {
    
    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure to delete?')
        .subscribe(
          (confirmed) => {
            
            if (!confirmed)
              return;

            this.deadlineService.delete(ID)
              .subscribe(
                (res) => {
                  if (res.status)
                    this.success(res.msg);
                  else
                    this.error(res.msg);
              });

    });
  }

  duplicate(ID) {
    
    this.confirmationDialogService.confirm('Duplicate Confirmation', 'Are you sure to duplicate?')
        .subscribe(
          (confirmed) => {
            
            if (!confirmed)
              return;

            this.deadlineService.duplicate(ID)
            .subscribe(
              (res) => {
                if (res.status)
                  this.success(res.msg);
                else
                  this.error(res.msg);
            });

    });


  }

  multiDelete() {

    var table1 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    this.confirmationDialogService.confirm('Multi Delete Confirmation', this.lang.removeallthis)
      .subscribe(
        (confirmed) => {
          
          if (!confirmed)
            return;

          this.deadlineService.multiDelete(selectedRows)
          .subscribe(
            (res) => {
              if (res.status)
                this.success(res.msg);
              else
                this.error(res.msg);
          });
      });
  }

  multiDuplicate() {

    var table1 = new $.fn.dataTable.Api('#table1');
    let selectedRows = table1.rows({ selected: true }).ids().toArray();

    this.confirmationDialogService.confirm('Multi Duplicate Confirmation', 'Are you sure to duplicate the selected rows?')
      .subscribe(
        (confirmed) => {
          
          if (!confirmed)
            return;

          this.deadlineService.multiDuplicate(selectedRows)
          .subscribe(
            (res) => {
              if (res.status)
                this.success(res.msg);
              else
                this.error(res.msg);
          });
      });

  }

  setPageView(view) {
    this.pageView = view;
  }

  // time_conversion(data) {
  //   return new Date(data.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3"));
  // }

  uploadFile() {  
    // console.log(this.fileInput.nativeElement.files[0]);
    let formData = new FormData();  
    formData.append('upload', this.fileInput.nativeElement.files[0]);
  
    this.deadlineService.UploadExcel(formData).subscribe(result => {  
      this.message = result.toString();  
    });   
  
  }  


  onPhotoPickerChange(ev){
    let file = ev.target.files[0];
     file = ev.target.files[0];

      // console.log(file.name);
      let file_name=file.name;
      if (!(/\.(csv)$/i).test(file_name)) {
          alert('Please upload valid excel file_name .csv only.');
          $('#file').val('');
      }
      else
      {
    let fs = new FileReader();
    fs.onload = (res:any)=>{
      this.getPhotoBase64 = res.target.result;
      $('#profile_input').val('');
    };
    fs.readAsDataURL(file);
    }
  }



  onclick(){    
    let profileImage = this.getPhotoBase64 ? this.getPhotoBase64.split(',').pop() : this.getPhotoBase64;
   
    if (profileImage != undefined && $('#file').val() != '')
    {
        this.deadlineService.updateProfile(profileImage)
        .subscribe(
          (res) => {            
            if (res.status) {
              this.success(res.msg);
              $("#datatableExport2").modal("hide");

            }
            else {
              this.error(res.msg);
              $("#datatableExport2").modal("hide");

            }
        });
    }
  }


  updsorting(data: any, table: any) {
    this.deadlineService.sorting(data, table)
      .subscribe(
        (res) => {
          if (res.status) {
            this.success(res.msg);

          }
          else {
            this.error(res.msg);

          }
        });
  }

  

  play(tid,oid) {
    this.tid = tid;
    this.oid = oid;

    $("#sactivate_plan").modal("show");
  }


  pause(sID) {

    this.confirmationDialogService.confirm('Deactivate Confirmation', 'Are you sure to deactivate?')
      .subscribe(
        (confirmed) => {

          if (!confirmed)
            return;

          this.deadlineService.updatePause(sID)
            .subscribe(
              (res) => {

                if (res.status) {
                  this.generalService.notify_msg('success', res.msg);

                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.Deadline_List]);
                    });

                  $("#sactivate_plan").modal("hide");
                }
                else {
                  this.generalService.notify_msg('error', res.msg);
                  $("#sactivate_plan").modal("hide");

                  this.router.navigateByUrl('/test', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate([AppFrontRoutes.Deadline_List]);
                    });

                }
              });
          
          $("#sactivate_plan").modal("hide");
        });
  }


  onSubmit(data) {
  //  console.log(data);
    
  this.deadlineService.updatePausePlay(data).subscribe(
    res => {

      if (res.status) {
        this.generalService.notify_msg('success', res.msg);
        // this.bsModalRef.hide();
        $("#sactivate_plan").modal("hide");

        
        this.router.navigateByUrl('/test', { skipLocationChange: true })
          .then(() => {
            this.router.navigate([AppFrontRoutes.Deadline_List]);
        });
      }
      else {
        this.generalService.notify_msg('error', res.msg);
        // this.bsModalRef.hide();
        $("#sactivate_plan").modal("hide");

      }

    }
  );

  }


}
